import React /* , { useState } */ from "react";
import { useNavigate } from "react-router-dom";
import { openCloudHumansChat } from "@/utils/cloudHumans";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@musa.tech/design-system";
// Mitigação temporária: formulário de feedback oculto até correção definitiva
// import { Textarea } from "@/components/ui/textarea";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MessageSquare, /* Bug, Lightbulb, */ ArrowLeft } from "lucide-react";
// import { useToast } from "@/hooks/use-toast";
// import { useAuthContext } from "@/components/AuthProvider";
// import { supabase } from "@/integrations/supabase/client";
// import { getKeycloakUidForSupabase } from "@/utils/keycloakUidForSupabase";

// const PENDING_FEEDBACK_KEY = "suporte_pending_feedback";

// /** Salva feedback localmente quando o usuário não está na tabela users (ex.: Keycloak geradores). */
// function saveFeedbackLocally(payload: { type: string; description: string; email: string }) {
//   try {
//     const raw = localStorage.getItem(PENDING_FEEDBACK_KEY);
//     const list: Array<{ type: string; description: string; email: string; at: string }> = raw ? JSON.parse(raw) : [];
//     list.push({ ...payload, at: new Date().toISOString() });
//     localStorage.setItem(PENDING_FEEDBACK_KEY, JSON.stringify(list.slice(-50)));
//   } catch {
//     // ignore
//   }
// }

const Suporte = () => {
  // const [feedbackType, setFeedbackType] = useState<'bug' | 'improvement' | ''>('');
  // const [description, setDescription] = useState('');
  // const [isLoading, setIsLoading] = useState(false);
  // const { toast } = useToast();
  // const { isAuthenticated, profile } = useAuthContext();
  const navigate = useNavigate();

  const handleWhatsAppClick = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=5511959590149&text&type=phone_number&app_absent=0",
      "_blank",
    );
  };

  const handleChatClick = () => {
    openCloudHumansChat();
  };

  // Mitigação temporária: formulário de feedback oculto até correção definitiva
  // const handleSubmitFeedback = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //
  //   if (!isAuthenticated) {
  //     toast({
  //       title: "Erro",
  //       description: "Você precisa estar logado para enviar feedback.",
  //       variant: "destructive",
  //     });
  //     return;
  //   }
  //
  //   if (!feedbackType || !description.trim()) {
  //     toast({
  //       title: "Erro",
  //       description: "Por favor, preencha todos os campos obrigatórios.",
  //       variant: "destructive",
  //     });
  //     return;
  //   }
  //
  //   setIsLoading(true);
  //
  //   try {
  //     const email = profile?.email;
  //     if (!email) {
  //       throw new Error('Email não disponível');
  //     }
  //     let uid: string | null = null;
  //     try {
  //       uid = await getKeycloakUidForSupabase({ profileEmail: email });
  //     } catch {
  //       uid = null;
  //     }
  //     // @ts-expect-error - RPC insert_feedback será adicionada aos tipos após aplicar migration
  //     const { error } = await supabase.rpc('insert_feedback', {
  //       p_auth_id: uid || '00000000-0000-0000-0000-000000000000',
  //       p_feedback_type: feedbackType,
  //       p_description: description.trim(),
  //       p_email: email,
  //     });
  //
  //     if (error) {
  //       const isNotFound =
  //         error?.message?.includes('não encontrado') || error?.details?.includes('não encontrado');
  //       if (isNotFound) {
  //         saveFeedbackLocally({
  //           type: feedbackType,
  //           description: description.trim(),
  //           email,
  //         });
  //         toast({
  //           title: "Sucesso",
  //           description: "Seu feedback foi registrado com sucesso! Obrigado pela contribuição.",
  //         });
  //         setFeedbackType('');
  //         setDescription('');
  //         return;
  //       }
  //       throw error;
  //     }
  //
  //     toast({
  //       title: "Sucesso",
  //       description: "Seu feedback foi enviado com sucesso! Obrigado pela contribuição.",
  //     });
  //
  //     setFeedbackType('');
  //     setDescription('');
  //   } catch (error) {
  //     console.error('Erro ao enviar feedback:', error);
  //     toast({
  //       title: "Erro",
  //       description: "Não foi possível enviar seu feedback. Tente novamente.",
  //       variant: "destructive",
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <div className="min-h-screen bg-background p-4 md:p-6 w-full overflow-x-hidden">
      <div className="max-w-7xl mx-auto space-y-4 md:space-y-6 min-w-0">
        <div className="mb-6 md:mb-8">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/configuracoes")}
              className="p-1 rounded-md hover:bg-accent transition-colors"
            >
              <ArrowLeft className="h-6 w-6 text-[#10261F]" />
            </button>
            <h1 className="text-2xl md:text-3xl font-bold text-[#10261F] ">
              Suporte
            </h1>
          </div>
          <p className="text-gray-600 mt-2  text-sm md:text-base">
            Fale com a gente ou envie sugestões para melhorar sua experiência.
          </p>
        </div>

        {/* Card de Atendimento Imediato */}
        <Card className="bg-white border-gray-200 shadow-sm">
          <CardHeader>
            <CardTitle className="text-xl font-bold text-[#10261F] ">
              Atendimento imediato
            </CardTitle>
            <CardDescription className="text-gray-600 ">
              Se precisar de ajuda com sua operação, fale com nosso time pelo
              chat ou pelo WhatsApp.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex flex-wrap gap-3">
            <Button
              onClick={openCloudHumansChat}
              className="bg-[#10261F] hover:bg-[#0D1F18] text-white font-medium"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Abrir chamado
            </Button>
            <Button
              onClick={handleWhatsAppClick}
              className="bg-[#25D366] hover:bg-[#20C05C] text-white font-medium"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </CardContent>
        </Card>

        {/* Mitigação temporária: Card de Feedback oculto até correção definitiva */}
        {/* <Card className="bg-white border-gray-200 shadow-sm">
          <CardHeader>
            <CardTitle className="text-xl font-bold text-[#10261F] ">
              Reportar um problema ou sugerir melhoria
            </CardTitle>
            <CardDescription className="text-gray-600 ">
              Use este formulário para enviar feedbacks sobre o portal. Não é um canal para suporte operacional.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmitFeedback} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-[#10261F] mb-2 ">
                  Tipo de feedback
                </label>
                <Select 
                  value={feedbackType} 
                  onValueChange={(value: 'bug' | 'improvement') => setFeedbackType(value)}
                  disabled={isLoading}
                >
                   <SelectTrigger className="w-full">
                     <SelectValue placeholder="Selecione uma opção" className="text-[hsl(var(--muted-foreground-lighter))]" />
                   </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="bug">
                      <div className="flex items-center">
                        <Bug className="w-4 h-4 mr-2" />
                        Bug
                      </div>
                    </SelectItem>
                    <SelectItem value="improvement">
                      <div className="flex items-center">
                        <Lightbulb className="w-4 h-4 mr-2" />
                        Melhoria
                      </div>
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className="block text-sm font-medium text-[#10261F] mb-2 ">
                  Descreva o que aconteceu ou sua sugestão
                </label>
                <Textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Descreva em detalhes o que ocorreu..."
                  className="min-h-[120px] resize-none"
                  disabled={isLoading}
                />
              </div>

              {!isAuthenticated && (
                <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                  <p className="text-sm text-yellow-800 ">
                    Você precisa estar logado para enviar feedback.
                  </p>
                </div>
              )}

              <Button
                type="submit"
                disabled={!isAuthenticated || isLoading || !feedbackType || !description.trim()}
                className="w-full bg-[#10261F] hover:bg-[#0D1F18] text-white  font-medium"
              >
                {isLoading ? 'Enviando...' : 'Enviar feedback'}
              </Button>
            </form>
          </CardContent>
        </Card> */}
      </div>
    </div>
  );
};

export default Suporte;
